export default __webpack_public_path__ + "static/media/Monk's Gloves of the Sacred Mountain.c0285721.jpg";